/* eslint-disable react/prop-types */
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Flex,
} from "@chakra-ui/react";
import { useLock, UserContext } from "../../context";
import { _basePath } from "../../config";
import { CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import { Trans } from "react-i18next";

function TimeoutModal({ isOpen, onClose, timeout }) {
  const { setUserData } = React.useContext(UserContext);
  const { clearLock } = useLock();
  const history = useHistory();
  const [timeLeft, setTimeLeft] = useState(timeout);
  const percentageLeft = (100 * timeLeft) / timeout;
  const onLogout = () => {
    clearLock().then(() => {
      setUserData({
        user: null,
        loggedIn: false,
      });
      onClose();
      history.push(_basePath);
    });
  };

  React.useEffect(() => {
    isOpen && timeLeft > 0 && setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    if (!timeLeft) {
      onLogout();
    }
    if (!isOpen) setTimeLeft(timeout);
  }, [timeLeft, isOpen]);

  const onContinue = () => {
    onClose();
  };

  return (
    <>
      <Modal textAlign="center" size="xl" isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text
              color="brand.primary.DEFAULT"
              className="modal-title"
              fontSize="4xl"
              textAlign="center"
            >
              <Trans i18nKey={"need_more_time"}>Need more time?</Trans>
            </Text>
          </ModalHeader>
          <ModalBody>
            <Flex direction={"column"} alignItems={"center"}>
              <CircularProgress
                size="100px"
                value={percentageLeft}
                thickness="6px"
                color="brand.primary.500"
              >
                <CircularProgressLabel color={"brand.primary.700"}>
                  {timeLeft}
                </CircularProgressLabel>
              </CircularProgress>
              <Text
                textAlign="center"
                color="brand.text.primary"
                fontSize="xl"
                mt={5}
              >
                <Trans i18nKey={"session_expiration"}>
                  This session is about to expire.
                </Trans>
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter justifyContent="center">
            <Button
              size="lg"
              onClick={onLogout}
              variant="primary"
              mr={5}
              data-testid={"idle-logout-button"}
            >
              <Trans i18nKey={"actions.log_out"}>Log Out</Trans>
            </Button>
            <Button
              size="lg"
              variant="kioskPrimary"
              onClick={onContinue}
              data-testid={"idle-continue-button"}
            >
              <Trans i18nKey={"actions.continue"}>Continue</Trans>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
export default TimeoutModal;
